import React from 'react';
import styles from './ui.module.css';

export type TradeSide = 'buy' | 'sell';

interface SideTagProps {
  side: TradeSide;
  /** Defaults to BUY / SELL. */
  children?: React.ReactNode;
  /** Green buy / red sell — the order screens' convention. Off by default. */
  colored?: boolean;
}

/**
 * Which side of a trade an order or section is on. A buy is not a gain and a
 * sell is not a loss, so by default this is navy-outlined for buy and neutral
 * for sell. Only the order-management tabs opt into green/red via `colored`.
 */
const SideTag: React.FC<SideTagProps> = ({ side, children, colored }) => {
  const tone = colored
    ? (side === 'buy' ? styles.sideBuyColored : styles.sideSellColored)
    : (side === 'buy' ? styles.sideBuy : styles.sideSell);
  return (
    <span className={`${styles.sideTag} ${tone}`}>
      {children ?? (side === 'buy' ? 'BUY' : 'SELL')}
    </span>
  );
};

export default SideTag;
